import { defineStore } from 'pinia'

export const useDocsStore = defineStore('docs', {
    state: () => ({
        activeItem: {}
    }),

    actions: {
        setActiveItem(d) {
            this.activeItem = d
        }
    }
})